// extracted by mini-css-extract-plugin
module.exports = {"emoji-button":"EmojiButton_emoji-button__3-hLS","emoji-button_active":"EmojiButton_emoji-button_active__1AZeg"};